import { render, staticRenderFns } from "./insurancecompanies.vue?vue&type=template&id=1da78ff9"
import script from "./insurancecompanies.vue?vue&type=script&lang=js"
export * from "./insurancecompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports